export const DEVICE_TYPE = {
    DEVICE_CONTROL:{
        type:'控制器',
        value:1,
        allow:true,
        control:false
    },
    DEVICE_RADIO:{
        type:'音箱',
        value:2,
        allow:false
    },
    DEVICE_LIGHT:{
        type:'空调',
        value:3,
        allow:true,
        control:false
    },
    DEVICE_PRINTER:{
        type:'打印机',
        value:4,
        allow:false
    },
    DEVICE_LOCK:{
        type:'锁',
        value:5,
        allow:true,
        control:false
    },
    DEVICE_PIA:{
        type:'智能货柜',
        value:6,
        allow:true,
        control:true
    }
}